<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="45"
		height="45"
		viewBox="0 0 45 45"
	>
		<defs>
			<clipPath id="a">
				<rect class="a" width="45" height="45" transform="translate(4071 3262)" />
			</clipPath>
		</defs>
		<g transform="translate(-1722 -852)">
			<g class="b" transform="translate(-2349 -2410)">
				<path
					d="M67.695,173.434c-.473-.392-.959-.783-1.433-1.165l-2.424-1.954,3.793-3.06a3.992,3.992,0,0,0,.663-.661,3.017,3.017,0,0,0-.688-4.321q-1.611-1.3-3.23-2.6l-8.364-6.738a3.953,3.953,0,0,0-4.962-.031c-4.555,3.662-8.267,6.65-11.66,9.394a3.029,3.029,0,0,0-.75,4.213,2.876,2.876,0,0,0,.736.738c.389.316.783.634,1.171.942l2.636,2.123-1.38,1.111c-.813.657-1.645,1.328-2.447,1.98a3.012,3.012,0,0,0-.059,4.847c.369.312.755.62,1.158.945l3.179,2.561c2.421,1.949,4.923,3.964,7.378,5.934a3.914,3.914,0,0,0,2.461.911,4.3,4.3,0,0,0,1.864-.461,5.148,5.148,0,0,0,.985-.683l1.943-1.57c3.1-2.493,6.31-5.073,9.438-7.612a3.091,3.091,0,0,0,1.233-2.414A3.189,3.189,0,0,0,67.695,173.434ZM51.837,163.5a7.983,7.983,0,0,0-1.811,1.3c-.214.186-.44.377-.667.553-.856.668-1.712,1.362-2.551,2.038l-.292.237c-.239.191-.477.385-.716.579l-1.477-1.19c-.9-.728-1.818-1.469-2.763-2.241l10.276-8.287Zm.567,3.614c.226-.186.456-.372.7-.563a.611.611,0,0,1,.765-.024c1.181.94,2.373,1.9,3.542,2.845l1.176.95q-2.022,1.633-4.056,3.266l-.537.434-.027.024a.668.668,0,0,1-.931-.018q-2.248-1.8-4.494-3.617l-.113-.09Zm2.775,10.036.061-.039a9.334,9.334,0,0,0,.944-.636c1.138-.905,2.286-1.831,3.411-2.734l1.615-1.3,4.24,3.415a.155.155,0,0,0,.02.015.259.259,0,0,0-.03.022l-10.261,8.271Zm3.126-11.3-.222-.18c-.675-.546-1.369-1.1-2.072-1.653a5.052,5.052,0,0,0-.73-.445l-.12-.063c-.007-2.331-.007-4.635-.007-7.047L64.51,164l.954.765c-.439.359-.881.714-1.313,1.061l-2.94,2.367-2.035-1.639C58.884,166.327,58.592,166.088,58.3,165.852ZM45.8,172.43l.962.774c1.338,1.083,2.722,2.2,4.1,3.283a8.537,8.537,0,0,0,.918.612l.065.038v7.007l-10.293-8.289q1.881-1.519,3.768-3.034Z"
					transform="translate(4039.565 3114.104)"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-bossabox',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
</style>

<docs>
    IconBossabox

    ```js
    <b-icon-bossabox />
    ```
</docs>
